/**
 * Add external stylesheets below.
 */

// Reset
import './reset.css'

// Primitives
import '@primer/brand-primitives/lib/design-tokens/css/tokens/base/colors/color-scales-with-modes.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/base/size/size.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/base/typography/typography.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/animation/base.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/size/size.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/typography/typography-responsive.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/size/breakpoints.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/size/border.css'
import '@primer/brand-primitives/lib/design-tokens/css/tokens/functional/colors/global-with-modes.css'

// Misc
import './utilities.css'

// Noop export to make sure this file isn't dropped when tree-shaken
export const _GLOBAL_STYLES = true
